export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se você cancelar a negociação, ela será fechada sem concluir a operação."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tem certeza de que deseja cancelar a negociação?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sim, cancelar"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Não, manter ativa"])}
}